import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioCardDefaultVariants = {}
const radioCardCompoundVariants = []

const radioCardSlotNames = [
  [
    "root",
    "RadioCard__root"
  ],
  [
    "control",
    "RadioCard__control"
  ],
  [
    "label",
    "RadioCard__label"
  ],
  [
    "description",
    "RadioCard__description"
  ],
  [
    "addon",
    "RadioCard__addon"
  ],
  [
    "content",
    "RadioCard__content"
  ]
]
const radioCardSlotFns = /* @__PURE__ */ radioCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioCardDefaultVariants, getSlotCompoundVariant(radioCardCompoundVariants, slotName))])

const radioCardFn = memo((props = {}) => {
  return Object.fromEntries(radioCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioCardVariantKeys = []
const getVariantProps = (variants) => ({ ...radioCardDefaultVariants, ...compact(variants) })

export const radioCard = /* @__PURE__ */ Object.assign(radioCardFn, {
  __recipe__: false,
  __name__: 'radioCard',
  raw: (props) => props,
  variantKeys: radioCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, radioCardVariantKeys)
  },
  getVariantProps
})